export const ALLERGENS = [
  { key: "glutine", emoji: "🌾", it: "Glutine", en: "Gluten" },
  { key: "crostacei", emoji: "🦐", it: "Crostacei", en: "Crustaceans" },
  { key: "uova", emoji: "🥚", it: "Uova", en: "Eggs" },
  { key: "pesce", emoji: "🐟", it: "Pesce", en: "Fish" },
  { key: "arachidi", emoji: "🥜", it: "Arachidi", en: "Peanuts" },
  { key: "soia", emoji: "🫘", it: "Soia", en: "Soybeans" },
  { key: "latte", emoji: "🥛", it: "Latte", en: "Milk" },
  { key: "frutta_a_guscio", emoji: "🌰", it: "Frutta a guscio", en: "Tree nuts" },
  { key: "sedano", emoji: "🥬", it: "Sedano", en: "Celery" },
  { key: "senape", emoji: "🟡", it: "Senape", en: "Mustard" },
  { key: "sesamo", emoji: "🟤", it: "Sesamo", en: "Sesame" },
  { key: "solfiti", emoji: "🍷", it: "Solfiti", en: "Sulphites" },
  { key: "lupini", emoji: "🌼", it: "Lupini", en: "Lupin" },
  { key: "molluschi", emoji: "🐚", it: "Molluschi", en: "Molluscs" },
];

export const allergenByKey = Object.fromEntries(ALLERGENS.map((a) => [a.key, a]));

// Rilevamento automatico dal nome ingrediente (IT/EN) — usato quando mancano le spunte manuali
const KW = {
  glutine: ["farina", "frumento", "grano", "orzo", "farro", "segale", "kamut", "avena", "pane", "pangratt", "biscott", "savoiard", "sfoglia", "pan di spagna", "semola", "malto", "couscous", "cous cous", "seitan", "wafer", "cereali", "flour", "wheat", "barley", "oat"],
  uova: ["uova", "uovo", "tuorl", "albume", "maionese", "egg", "mayo"],
  latte: ["latte", "burro", "panna", "mascarpone", "ricotta", "yogurt", "formagg", "mozzarell", "parmigian", "grana padano", "pecorino", "philadelphia", "lattosio", "besciamell", "caseina", "stracchino", "gorgonzola", "robiola", "milk", "butter", "cream", "cheese"],
  frutta_a_guscio: ["nocciol", "mandorl", "pistacch", "anacard", "noci", "noce", "gianduia", "pralinat", "macadamia", "pecan", "almond", "hazelnut", "walnut", "cashew"],
  arachidi: ["arachid", "peanut"],
  soia: ["soia", "tofu", "edamame", "soy"],
  sesamo: ["sesamo", "tahin", "sesame"],
  crostacei: ["gamber", "scampi", "granchi", "aragost", "astice", "mazzancoll", "shrimp", "prawn", "crab", "lobster"],
  pesce: ["pesce", "tonno", "salmone", "acciug", "alici", "merluzz", "branzino", "orata", "sgombro", "baccal", "fish", "tuna", "salmon", "anchov"],
  molluschi: ["cozze", "vongol", "calamar", "seppi", "polpo", "ostrich", "capesant", "lumach", "mussel", "clam", "squid", "octopus"],
  sedano: ["sedano", "celery"],
  senape: ["senape", "mostarda", "mustard"],
  solfiti: ["vino", "marsala", "solfit", "sulphit", "sulfit", "wine"],
  lupini: ["lupin"],
};
const EXCL = {
  glutine: ["farina di riso", "farina di mais", "farina di castagne", "farina di ceci", "farina di mandorle", "farina di cocco", "senza glutine", "gluten free", "gluten-free"],
  latte: ["burro di cacao", "latte di cocco", "latte di riso", "latte di soia", "latte di mandorla", "latte d'avena", "latte di avena", "senza lattosio", "lactose free", "cocoa butter", "coconut milk"],
  frutta_a_guscio: ["noce moscata", "nutmeg"],
};

export function detectAllergens(name) {
  const s = (name || "").toLowerCase();
  if (!s) return [];
  const out = [];
  for (const [k, kws] of Object.entries(KW)) {
    if (!kws.some((w) => s.includes(w))) continue;
    if ((EXCL[k] || []).some((e) => s.includes(e))) continue;
    out.push(k);
  }
  return out;
}

const GRAMS = { kg: 1000, g: 1, l: 1000, ml: 1, lb: 453.59, oz: 28.35 };
const NUTR = ["kcal", "carbs", "protein", "fat", "satfat", "sugars", "fiber", "salt"];

export function recipeNutrition(recipe, ingsById) {
  const tot = { kcal: 0, carbs: 0, protein: 0, fat: 0 };
  const allergens = new Set([...detectAllergens(recipe.name), ...(recipe.allergens || [])]);
  let hasData = false;
  for (const row of recipe.ingredients || []) {
    const ing = ingsById[row.ingredient_id];
    const als = (ing?.allergens?.length ? ing.allergens : detectAllergens(ing?.name || row.name));
    als.forEach((a) => allergens.add(a));
    if (!ing) continue;
    const q = +row.quantity || 0;
    const factor = ing.unit === "pcs" ? q : ((GRAMS[ing.unit] ?? 1) * q) / 100;
    for (const k of NUTR) {
      const v = ing[`${k}_100`];
      if (v != null && v !== "") { tot[k] += factor * +v; hasData = true; }
    }
  }
  const y = +recipe.yield_qty || 1;
  const isPcs = (recipe.yield_unit || "pcs") === "pcs";
  const totalGrams = isPcs ? null : (GRAMS[recipe.yield_unit] ?? 1) * y;
  const div = isPcs ? y : totalGrams / 100;
  const perPortion = {};
  for (const k of NUTR) perPortion[k] = div > 0 ? +(tot[k] / div).toFixed(1) : 0;
  return { perPortion, portionLabel: isPcs ? "1 pz" : "100 g", hasData, allergens: [...allergens] };
}
